import { Component, Input } from '@angular/core';

@Component({
    selector: 'carm-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
})
export class CardComponent {

  @Input() theme: 'white' | 'grey' | 'blue' = 'grey'; // default to grey
  @Input() corners: 'square' | 'round' = 'square'; // default to square

}
